import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CollectionInspectionTypeState } from './_state/collection-inspection-type.state';

@Injectable({ providedIn: 'root' })
export class CollectionInspectionTypeService {

  constructor(
    public state: CollectionInspectionTypeState,
  ) {

  }

  get currentTypeInspection$(): Observable<any> {
    return this.state.currentTypeInspection$;
  }

  changeInspectionType(pCollection: any): void {
    this.state.changeCurrentInspectionType(pCollection);
  }

}
